module.exports = __webpack_public_path__ + "static/img/highway-12-wayside-exhibits11.be1fc64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/highway-12/highway-12-wayside-exhibits11.jpg
// module id = 911
// module chunks = 0